import ApiService from "../../services/api.service";
import { Notify } from 'quasar';
import { useStore } from 'vuex';
import NotifyDefaults from "@boot/notify-defaults";

export const userAlertes = {
  state: {
    userAlertes: [],
    userAlerte: null,
    object: null
  },
  mutations: {
    setUserAlertes(state, userAlertes) {
      state.userAlertes = userAlertes;
    },
    setUserAlerte(state, userAlerte) {
      state.userAlerte = userAlerte;
    },
    callbackEditAlertes(state, payload) {
      state.object = payload.object;
    }
  },
  actions: {
    /*ALERTE TYPE UTILISATEUR (POST, ADD, GET) */
    async fetchUserAlertes({commit, rootState, rootGetters}){
      try {
        // On quitte la fonction car l'utilisateur n'est pas connecté
        if (!rootGetters['auth/isLoggedIn']) {
          return;
        }
        const userId = rootState.auth.user?.id;
        const response = await ApiService.getRequest('user_alertes_global_params', {user: userId})
        commit('setUserAlertes', response.data['hydra:member']);
      } catch (error)  {
        console.error(error);
        Notify.create({
          message: "Un erreur s'est produite",
          color: 'red'
        })
      }
    },

    //Fetch PAge d'acceuil baser sur les données de l'utilisateur
    async fetchUserAlertesATraiter(context){
      try{
        const response = await ApiService.getRequest('/get_alertes');
        context.commit("setUserAlertes", response.data);

      }catch (e) {
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite lors de la récupération des alertes",
          color: 'red'
        });
      }
    },

    async addUserParametersAlertes({state}, data){
      try {
       const response = await ApiService.postRequest('edit_user_alertes_global_params/', data);
        if(response.status === 200) {
          this.commit('callbackEditAlertes', response.data);
          Notify.create({
            message: 'Les paramètres de vos alertes ont bien été ajoutés avec succès.',
            color: 'green'
          })
          return Promise.resolve();
        } else {
          return Promise.reject(new Error('La requête a échoué.'));
        }
      } catch (error) {
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout de vos données",
          color: "red"
        })
        return Promise.reject(error);
      }
    },

    async statusAlertes(context, alerteEtat){
      try {
        const response = await ApiService.patchRequest(`${alerteEtat.uri}`);
        if(response.status === 200){
          this.commit('callbackEditAlertes', response)
          Notify.create({
            message: 'Le status de cette alerte a été enregister avec succès',
            color: 'green'
          })
          return Promise.resolve();
        }
      } catch (error) {
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },
  },
  getters: {
    getUserAlertes(state) {
      return state.userAlertes;
    },
    getUserALerte(state){
      return state.userAlerte;
    }
  }
}
